import { render } from "./YourBodyType.vue?vue&type=template&id=dfab7752&scoped=true"
import script from "./YourBodyType.vue?vue&type=script&lang=js"
export * from "./YourBodyType.vue?vue&type=script&lang=js"

import "./YourBodyType.vue?vue&type=style&index=0&id=dfab7752&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfab7752"]])

export default __exports__